import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import type { BizminerIndustry } from "@/types/serializers";

const NONE = "__none__";

interface IndustrySelectProps {
  value: number | null;
  onChange: (value: number | null) => void;
  industries: BizminerIndustry[];
}

/**
 * Flat picker over an organization's assignable industries.
 *
 * Deliberately not IndustrySelector — that browses the hierarchical GICS tree.
 * This is a short, org-owned list, so a plain select is the right control.
 */
export function IndustrySelect({
  value,
  onChange,
  industries,
}: IndustrySelectProps) {
  return (
    <Select
      value={value ? String(value) : NONE}
      onValueChange={(next) => onChange(next === NONE ? null : Number(next))}
    >
      <SelectTrigger>
        <SelectValue placeholder="Select an industry" />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value={NONE}>None</SelectItem>
        {industries.map((industry) => (
          <SelectItem key={industry.id} value={String(industry.id)}>
            {industry.name}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}

export default IndustrySelect;
